import React, { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { authFetch } from "../../data/api";

export default function AccountEditor() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const cls =
    "w-full bg-transparent border-b border-navy/20 py-2.5 text-navy placeholder:text-navy/35 focus:outline-none focus:border-gold transition-colors";

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("La nuova password deve avere almeno 8 caratteri");
      return;
    }
    if (next !== confirm) {
      toast.error("Le due nuove password non coincidono");
      return;
    }
    setSaving(true);
    try {
      await authFetch("/admin/change-password", {
        method: "POST",
        body: { currentPassword: current, newPassword: next },
      });
      toast.success("Password aggiornata con successo");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(err.detail || "Impossibile aggiornare la password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md">
      <div className="mb-8 pb-6 border-b border-navy/10">
        <h2 className="font-serif font-light text-3xl text-navy">Password</h2>
        <p className="text-navy/55 text-sm mt-1">Cambia la password di accesso all'area amministratore.</p>
      </div>

      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="block text-[0.62rem] uppercase tracking-[0.18em] text-navy/45 mb-2">Password attuale</label>
          <input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} className={cls} />
        </div>
        <div>
          <label className="block text-[0.62rem] uppercase tracking-[0.18em] text-navy/45 mb-2">Nuova password (min. 8 caratteri)</label>
          <input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className={cls} />
        </div>
        <div>
          <label className="block text-[0.62rem] uppercase tracking-[0.18em] text-navy/45 mb-2">Conferma nuova password</label>
          <input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={cls} />
        </div>
        <button
          type="submit"
          disabled={saving || !current || !next || !confirm}
          className="inline-flex items-center gap-2 bg-navy text-paper px-6 py-3 text-xs uppercase tracking-[0.2em] hover:bg-gold transition-colors disabled:opacity-50"
        >
          {saving ? <Loader2 size={15} className="animate-spin" /> : <KeyRound size={15} />} Aggiorna password
        </button>
      </form>
    </div>
  );
}
